import styled, { css } from 'styled-components';

export const TransportDataContainter = styled.div`
  display: flex;  
  justify-content: flex-start;
  flex: 1;

  ${({ isTablet }) => (isTablet && css`
    margin-left: 20px;
  `)}

  ${({ isMobile }) => isMobile && css`
    margin: 24px;
  `}
`;

export const LineWrapper = styled.div``;

export const InfoRow = styled.div`
  display: flex;
  align-items: ${({ lastRow }) => (lastRow ? 'flex-start' : 'center')};
`;

export const BulletPoints = styled.div`
  border-radius: 50%;
  width: 10px;
  height: 10px;
  background-color: var(--light-blue);
`;

export const ContentRow = styled.div`
  width: 100%;
`;

export const Line = styled.div`
  background-color: var(--light-blue);
  min-height: 70px;
  width: 2px;
  margin: -4px 12px 0 4px;
`;

export const LocationWrapper = styled.div`
`;

export const LocationNameText = styled.span`
  font-size: 16px;
  line-height: 14px;
  text-transform: uppercase;
  font-family: 'Work Sans';
  color: var(--luft-primary);
  margin-left: 8px;
`;

export const DestinationNameText = styled.span`
  font-size: 12px;
  line-height: 14px;
  display: flex;
  align-items: center;
  font-family: 'Work Sans';
  color: var(--light-opacity-dark);
  margin-left: 8px;
`;

export const ResendSignText = styled.span`
  font-size: 14px;
  line-height: 14px;
  font-family: 'Work Sans';
  color: var(--luft-secondary-gray);
  margin-left: 8px;
`;

export const DestinationDataWrapper = styled.div`
  display: flex;
  margin-top: -2px;
  margin-bottom: 4px;
  align-items: center;
`;

export const ShippingCompany = styled.div`
  color: rgba(0, 0, 0, 0.87);
  line-height: 14px;
  font-size: 14px;
  font-family: 'Work Sans';
  display: flex;
  align-items: center;
  gap: 8px;
`;

export const ShippingCompanyIcon = styled.img`
  width: 24px;
  height: 24px;
`;
